import http from '@/plugins/api'
import * as types from './types'
import {
  startLoading
} from '@/plugins/loading'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setActiveTab({
    commit,
    state
  }, tab) {
    commit('SET_ACTIVE_TAB', tab)
  },
  setNewTeam({
    commit,
    state
  }) {
    commit('SET_TEAM', [])
  },
  setSelectedId({
    commit,
    state
  }, {
    id,
    reset
  }) {
    commit('SET_SELECTED_ID', {
      id,
      reset
    })
    // Highlight the Team
    const teamTreeElements = document.querySelectorAll('.TeamTree .tree-node-wrapper')
    for (let i = 0; i < teamTreeElements.length; i++) {
      const teamTreeElement = teamTreeElements[i]

      if (teamTreeElement.id === String(id)) {
        teamTreeElement.style.backgroundColor = '#b8b8b8'
      } else {
        teamTreeElement.style.backgroundColor = 'transparent'
      }
    }
  },
  setTimeZoneList({
    commit,
    state
  }, value) {
    commit('SET_TIME_ZONE_LIST', value)
  },
  setLanguageList({
    commit,
    state
  }, value) {
    commit('SET_LANGUAGE_LIST', value)
  },
  setMakeList({
    commit,
    state
  }, value) {
    commit('SET_MAKE_LIST', value)
  },
  setRegionList({
    commit,
    state
  }, value) {
    commit('SET_REGION_LIST', value)
  },
  setScanTypeCertificationList({
    commit,
    state
  }, value) {
    commit('SET_SCAN_TYPE_CERTIFICATION_LIST', value)
  },
  setStateCertificationList({
    commit,
    state
  }, value) {
    commit('SET_STATE_CERTIFICATION_LIST', value)
  },
  setSelectedTeamMemberId({
    commit,
    state
  }, teamMember) {
    commit('SET_SELECTED_TEAM_MEMBER_ID', teamMember)
  },
  setSelectedContactId({
    commit,
    state
  }, id) {
    commit('SET_SELECTED_CONTACT_ID', id)
  },
  setMemberAttributeSelectedValues({
    commit,
    state
  }, value) {
    commit('SET_MEMBER_ATTRIBUTE_SELECTED_VALUES', value)
  },
  async getSelectedMemberProfile({
    commit,
    state,
    dispatch
  }, value) {
    const res = await startLoading(dispatch, 'getSelectedMemberProfile', () =>
      http.get(`user/GetUserByName?username=${value.Username}`)
    )
    if (res.data) {
      commit('SET_SELECTED_MEMBER_PROFILE', res.data[0])
    } else {
      commit('SET_SELECTED_MEMBER_PROFILE', null)
    }
  },
  setTeamLead({
    commit
  }, lead) {
    commit('SET_TEAM_LEAD', lead)
  },
  setTeamName({
    commit
  }, data) {
    commit('SET_TEAM_NAME', data)
  },
  async getTeam({
    commit,
    state,
    dispatch
  }, sid) {
    const r = await startLoading(dispatch, 'getTeam', () =>
      http.get(`TeamQuery/GetTeam/?id=${sid}`)
    )
    commit(types.SET_TEAM, r.data)
    return r.data
  },
  async getTeamTree({
    commit,
    state,
    dispatch
  }, id) {
    // console.log('getTeamTree: getting Team Tree ', id)
    const r = await startLoading(dispatch, 'getTeamTree', () =>
      http.get(`TeamQuery/GetTeamTree/?rootId=${id}`)
    )
    commit(types.SET_TEAM_TREE, r.data)
  },
  async getTeamLead({
    commit,
    state,
    dispatch
  }, contact) {
    const r = await startLoading(dispatch, 'getTeamLead', () =>
      http.get(`TeamQuery/GetTeamLead/?id=&contact=${contact}`)
    )
    commit(types.SET_TEAM_LEAD, r.data)
    return r.data
  },
  async getTeamMemberIds({
    commit,
    state,
    dispatch
  }, id) {
    const r = await startLoading(dispatch, 'getTeamMemberIds', () =>
      http.get(`TeamQuery/GetTechnicianIds/?id=${id}`)
    )
    commit(types.SET_TEAM_MEMBER_IDS, r.data)
    return r.data
  },
  async getTeamMemberIdsByLead({
    commit,
    state,
    dispatch
  }, data) {
    const r = await startLoading(dispatch, 'getTeamMemberIdsByLead', () =>
      http.get(`TeamQuery/GetTechnicianIds/?teamLeadId=${data.id}&filter=${data.filter}`)
    )
    commit(types.SET_TEAM_MEMBER_IDS, r.data)
    return r.data
  },
  async getTeamMembers({ commit, state, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getTeamMembers', () =>
      http.get(`UserQuery/GetTechniciansWithSearchOptions`, {
        params: searchOptions
      })
    )
    commit(types.SET_TEAM_MEMBERS, r.data)
    return r.data
  },
  async searchTechnicians({
    commit,
    state,
    dispatch
  }, searchTerm) {
    let data = await http.get(`UserQuery/SearchTechnicians/?search=${searchTerm}`)
    let _technicians = []
    for (let tech of data.data) {
      let technician = {
        name: tech.FamilyName + ', ' + tech.GivenName + ' (' + tech.Username + ')',
        code: tech.Id,
        lastName: tech.FamilyName
      }
      _technicians.push(technician)
    }
    commit(types.SET_TECHNICIANS, _technicians)
    return _technicians
  },
  async getTeamMemberProfile({
    commit,
    state,
    dispatch
  }, teamid, contactid) {
    const r = await startLoading(dispatch, 'getTeamMemberProfile', () =>
      http.get(`TeamQuery/GetTechnicianProfile/?teamid=${teamid}&contactid=${contactid}`)
    )
    console.log('getTeamMemberProfile', r.data)
    commit(types.SET_MEMBER_PROFILE, r.data)
  },
  async getTeamMemberAttributeTableData({
    commit,
    state,
    dispatch
  }, selectedTeamMember) {
    const r = await startLoading(dispatch, 'getTeamMemberAttributeTableData', () =>
      http.get(`TeamQuery/GetTeamMemberAttributeList/?teamid=${selectedTeamMember.TeamId}&memberid=${selectedTeamMember.ContactId}`)
    )
    // console.log('getTeamMemberAttributeTableData: Team Member = ' + selectedTeamMember.TeamId, selectedTeamMember.ContactId)
    let _attributeData = []
    for (let attr of r.data) {
      let attrData = {
        TeamMemberId: attr.TeamMemberId,
        TeamId: attr.TeamId,
        AttributeName: attr.AttributeName,
        AttributeType: attr.AttributeType,
        AttributeValue: attr.AttributeValue,
        AttributeId: attr.AttributeId
      }
      _attributeData.push(attrData)
    }
    // console.log('getTeamMemberAttributeTableData', _attributeData)
    return _attributeData
  },
  async getTeamMemberAttributes({
    commit,
    state,
    dispatch
  }, selectedTeamMember) {
    // state.memberAttributeSelectedValues = []
    // state.attributes = []
    const r = await startLoading(dispatch, 'getTeamMemberAttributes', () =>
      http.get(`TechAttributes/GetAllTechAttribs/?id=${selectedTeamMember.ContactId}`)
    )
    // console.log('getTeamMemberAttributes: using GetAllTechAttribs for Team Member = ' + selectedTeamMember.ContactId, r.data)
    commit(types.SET_TEAM_MEMBER_ATTRIBUTES, r.data)
  },
  async emptyMemberAttributeSelectedValues({
    commit
  }, data) {
    // console.log('emptyMemberAttributeSelectedValues')
    commit(types.SET_MEMBER_ATTRIBUTE_SELECTED_VALUES_TO_EMPTY, data)
  },
  async createTeam({
    commit,
    state,
    dispatch
  }, team) {
    // console.log('createTeam(action): creating Team ' + team.name, team)
    const r = await startLoading(dispatch, 'createTeam', () =>
      http.post(`c/Team/Upsert`, team)
    )
    commit(types.SET_ID, r.data)
  },
  async deleteTeam({
    commit,
    state,
    dispatch
  }, id) {
    // console.log('deleteTeam: deleting Team Id = ' + id, state.selectedTeamName, state.selectedTimeZone)
    await startLoading(dispatch, 'deleteTeam', () =>
      http.post(`c/Team/Delete`, {
        Id: id,
        Name: state.selectedTeamName,
        TimeZone: state.selectedTimeZone
      })
    )
  },
  async createTeamMember({
    commit,
    state,
    dispatch
  }, selectedTeamMember) {
    // console.log('createTeamMember: creating Team Member = ' + selectedTeamMember.name, selectedTeamMember.code)
    var member = {
      TeamId: state.selectedTeamId,
      ContactId: selectedTeamMember.code
    }
    await http.post(`c/Team/UpsertMember`, member)
  },
  async deleteTeamMember({
    commit,
    state,
    dispatch
  }, teamMember) {
    commit(types.SET_SELECTED_TEAM_MEMBER_ID, teamMember)
    // console.log('actions/deleteTeam: deleting Team Member Id = ' + state.selectedTeamMemberId, state.selectedTeamMemberName, state.selectedTeamName, state.selectedTeamId)
    await startLoading(dispatch, 'deleteTeam', () =>
      http.post(`c/Team/DeleteMember`, teamMember)
    )
  },
  async saveTeamMemberAttributes({
    commit,
    state,
    dispatch
  }, teamMemberAttributes) {
    var teamMember = []
    for (var val = 0; val < teamMemberAttributes.attributes.length; val++) {
      //  console.log(teamMemberAttributes)
      var tmpTeamMember = {
        TeamMemberId: teamMemberAttributes.id,
        TeamId: teamMemberAttributes.teamid,
        AttributeName: teamMemberAttributes.attributes[val].attributeId,
        AttributeValue: teamMemberAttributes.attributes[val].attributeValue
      }
      teamMember.push(tmpTeamMember)
    }
    var member = {
      memberid: teamMemberAttributes.id,
      teamid: teamMemberAttributes.teamid,
      attributes: teamMember
    }
    // console.log('actions/saveTeamMemberAttributes - upserting member attributes: ', member)
    if (member.attributes.length > 0) {
      await http.post(`TechAttributes/UpsertTeamMemberAttribute`, member)
    }
  },
  // async saveTeamMemberProfile({
  //   commit,
  //   state,
  //   dispatch
  // }, teamMemberProfile) {
  //   const r = await startLoading(dispatch, 'saveTeamMemberProfile', () =>
  //     http.post(`c/Team/UpsertMemberProfile`, teamMemberProfile)
  //   )
  //   commit(types.SET_MEMBER_PROFILE_ID, r.data)
  //   // console.log('actions/saveTeamMemberProfile: saving Team Member Profile = ' + teamMemberProfile, state.selectedTeamMemberId, state.selectedTeamMemberName, state.selectedTeamName, state.selectedTeamId)
  // },
  async saveTeamMemberProfile({
    commit,
    state,
    dispatch
  }, data) {
    // console.log('saving team member profile phone details', data)
    const r = await startLoading(dispatch, 'saveTeamLead', () =>
      http.post(`TeamQuery/UpsertTeamMemberProfile?memberid=${data.memberid}&notes=${data.notes}&phonenumber=${data.phonenumber}&phoneextension=${data.phoneextension}&maxWorkOrders=${data.maxWorkOrders}`)
    )
    commit(types.SET_PROFILE_TEAM_LEAD, r.data)
    return r.data
  },
  async deleteTeamMemberAttributes({
    commit,
    state,
    dispatch
  }, teamMemberAttributes) {
    var teamMember = {
      memberid: teamMemberAttributes.id,
      teamid: teamMemberAttributes.teamid,
      attributes: teamMemberAttributes.attributes
    }
    var r = ''
    r = await startLoading(dispatch, 'deleteTeamMemberAttributes', () =>
      http.post(`TechAttributes/DeleteTeamMemberAttributes`, teamMember)
    )
    commit(types.SET_MEMBER_PROFILE_ID, r.data)
    // console.log('actions/deleteTeamMemberAttributes: deleting Team Member Attributes = ' + teamMemberAttributes, state.selectedTeamMemberId, state.selectedTeamMemberName, state.selectedTeamName, state.selectedTeamId)
  },
  async getAllMemberAttributeSelectedValues({
    commit,
    dispatch
  }) {
    // var list = types.SET_MEMBER_ATTRIBUTE_OPTIONS
    // commit(types.SET_MEMBER_ATTRIBUTE_SELECTED_VALUES, list)
  },
  async saveTeamLead({
    commit,
    dispatch
  }, data) {
    console.log('saving team lead', data)
    const r = await startLoading(dispatch, 'saveTeamLead', () =>
      http.post(`TeamQuery/TeamLeadSave?id=${data.id}&contactId=${data.contactId}&name=${data.name}`)
    )
    commit(types.SET_PROFILE_TEAM_LEAD, r.data)
    return r.data
  },
  async saveStateCertificationId({
    commit,
    state,
    dispatch
  }, data) {
    // console.log('saving state certification Id', data)
    const r = await startLoading(dispatch, 'saveStateCertificationId', () =>
      http.post('TechAttributes/UpsertStateCertificationDetails', data)
    )
    commit(types.SET_STATE_CERTIFICATION_ID, r.data)
    return r.data
  },
  async getStateCertificationList({
    commit,
    state,
    dispatch
  }, selectedTeamMember) {
    const r = await startLoading(dispatch, 'getStateCertificationList', () =>
      http.get(`TechAttributes/GetTeamMemberStateCertificaiton/?id=${selectedTeamMember.ContactId}`)
    )
    commit(types.SET_STATE_CERTIFICATION_IDS_LIST, r.data)
  },
  async setStateCertificationListToNull({
    commit,
    state,
    dispatch
  }, setToNull) {
    commit(types.SET_STATE_CERTIFICATION_IDS_LIST, setToNull)
  },
  async setStateCertificationId({
    commit,
    state,
    dispatch
  }, certificationId) {
    commit(types.SET_STATE_CERTIFICATION_IDS_LIST, { certificationId })
  },
  async setCertificationTxtDisabled({
    commit,
    state,
    dispatch
  }, isDisabled) {
    commit(types.SET_STATE_CERTIFICATION_ID_TXT_ISDISABLED, isDisabled)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/teams/actions.js